/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Represents the base control component.
 */

export default class Control extends Component {

    /**
     * Properties.
     */

    static propTypes = {
        leftgap:        PropTypes.number,
        rightgap:       PropTypes.number,
        topgap:         PropTypes.number,
        bottomgap:      PropTypes.number
    }

    /**
     * Default property values.
     */

    static defaultProps = {
        leftgap:        0,
        rightgap:       0,
        topgap:         0,
        bottomgap:      0
    }

    /**
     * Gets the base style of the component.
     * 
     * @return  {Object}    style   style of the component
     */

    _getStyle = () => {
        return {
            marginLeft: (this.props.leftgap || 0) + 'px',
            marginRight: (this.props.rightgap || 0) + 'px',
            marginTop: (this.props.topgap || 0) + 'px',
            marginBottom: (this.props.bottomgap || 0) + 'px'
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Control/Control.js